import {horFPLogo} from '../images/horizontalLogoURL';
import {vertFPLogo} from '../images/verticalLogoURL';
import ASCIIFolder from "fold-to-ascii";

export const HMARGIN = 7;
export const RPTFONTSTYLE = "helvetica";

//***REPORT CONSTANTS***
//dimensions in mm:
//letter: 215.9 x 279.4
//a4:     210   x 297

export const getFormatValues = (doc) => {
  var titleXPos = doc.internal.pageSize.getWidth()/2;
  var splitWidth = doc.internal.pageSize.getWidth()-(2*HMARGIN);
  return{
    splitWidth,
    titleXPos
  }
}

export function setHeaderStyle(doc){
  doc.setFont(RPTFONTSTYLE, "italic");
  doc.setFontSize(14);
}

export function setBodyStyle(doc){
  doc.setFont(RPTFONTSTYLE, "normal");
  doc.setFontSize(10);
}

export function addSubHeader(doc, yPos, title){
  yPos = newPageCheck(doc, yPos);
  setHeaderStyle(doc);
  doc.text(HMARGIN, yPos, title);
  doc.setDrawColor(0);
  doc.line(HMARGIN, yPos+1, doc.internal.pageSize.getWidth() - HMARGIN, yPos+1);
  return (yPos+7);
}

export function convertTextForjsPDF(text){
  text = text.replace(/<.*?>/gm, '');
  text = text.replace(/&ldquo;/g, "\"");
  text = text.replace(/&rdquo;/g, "\"");
  text = text.replace(/&ndash;/g, "-");
  text = text.replace(/&amp;/g, "&");
  text = text.replace(/&rsquo;/g, "'");
  text = ASCIIFolder.foldReplacing(text);

  return text;
}

export function createTextSection(doc, yPos, text, header, splitWidth){
  text = convertTextForjsPDF(text);
  var columns = [
    {title: header, dataKey:"t"},
  ];
  var rows = [{"t":text}];
  //use autoTable to facilitate splitting text over multiple pages if needed
  doc.autoTable(columns, rows, {
    theme: 'plain',
    styles: {overflow: 'linebreak'},
    showHeader: 'firstPage',
    margin: {horizontal:HMARGIN, bottom: 19},
    addPageContent: tableFooter,
    startY: yPos,
  })
  yPos = doc.autoTable.previous.finalY + 5;
  return yPos;
}

export const newPageCheck = (doc, yPos) => {
  if(yPos > doc.internal.pageSize.getHeight()-30){
    addNewPage(doc);
    return 20;
  }
  return yPos;
}

export const addNewPage = (doc) => {
  doc.addPage();
  writePageNumber(doc);
  writeTNCFooter(doc);
}

export const tableFooter = (data) => {
  writePageNumber(data.doc);
  writeTNCFooter(data.doc);
}

export const writeTNCFooter = (doc) => {
  //font styles is a bit wonky, cant get old fontstyle from doc.internal
  var oldFontSize = doc.internal.getFontSize();
  doc.setFont(RPTFONTSTYLE, 'normal');
  doc.setFontSize(7);
  doc.text(doc.internal.pageSize.getWidth()-25, doc.internal.pageSize.getHeight()-7, "This report was generated by FishPath, a product of The Nature Conservancy", null, null, 'right')
  doc.setFontSize(oldFontSize);
  //FP-TNC horizontal logo size ratio: 525 X 138 => 3.804:1
 //doc.addImage(horFPLogo, 'JPEG', 15, doc.internal.pageSize.getHeight()-15, 60, 60/3.804);
 //NEW horizontal logo ratio: 525x89 => 5.899:1
 doc.addImage(horFPLogo, 'JPEG', 15, doc.internal.pageSize.getHeight()-15, 60, 60/5.899, "footerLogo");
}

export const placeTitleLogo = (doc) => {
  //FP-TNC vert logo size ratio: 437 x 439
  //doc.addImage(vertFPLogo, 'JPEG', getFormatValues(doc).titleXPos - 25, doc.internal.pageSize.getHeight()*(0.5), 50, 50/0.995)
  //NEW vert logo size ratio: 437x525
  var imgData = vertFPLogo;
  doc.addImage(imgData, 'JPEG', getFormatValues(doc).titleXPos - 25, doc.internal.pageSize.getHeight()*(0.5), 50, 50/0.832, "titleLogo")
}

export const writePageNumber = (doc) => {
  //font styles is a bit wonky, cant get old fontstyle from doc.internal
  var oldFontSize = doc.internal.getFontSize();
  doc.setFont(RPTFONTSTYLE, 'normal');
  doc.setFontSize(10);
  doc.text(doc.internal.pageSize.getWidth()-20 , doc.internal.pageSize.getHeight()-7, '[' + doc.internal.getNumberOfPages() + ']')
  doc.setFontSize(oldFontSize);
}

//count the total number of criteria accounting for multi-part criteria
export function countCriteria(criteriaArr, option){
  var numCrit = 0;
  var orIDs = [];
  for(var i=0; i <criteriaArr.length; i++){
    if(!criteriaArr[i].or){
      numCrit++;
    }else{
      if(!orIDs.includes(criteriaArr[i].or)){
        orIDs.push(criteriaArr[i].or);
        numCrit++;
      }
    }
  }
  return numCrit;
}

export function downloadCSV(csvData, exportName) {
  var blob = new Blob(["\ufeff", csvData], { type: 'text/csv;charset=utf-8;' }); //prepending "\ufeff" to beginning allows excel to properly display spanish characters
  var now = new Date();
  exportName = exportName + " - " + now.toLocaleDateString() + ".csv";
  if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, exportName);
  } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      }
  }
}
